import { render, staticRenderFns } from "./TextElement.vue?vue&type=template&id=e822fbc6&scoped=true"
import script from "./TextElement.vue?vue&type=script&lang=js"
export * from "./TextElement.vue?vue&type=script&lang=js"
import style0 from "./TextElement.vue?vue&type=style&index=0&id=e822fbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e822fbc6",
  null
  
)

export default component.exports